module.exports = __webpack_public_path__ + "img/close.e1498843.png";